import { combineReducers } from 'redux'
import reducer from '../reducers/reducer'

const rootReducer = combineReducers({
  reducer,
})

export default rootReducer
